// Targets do cenário conservador do modelo financeiro (12 meses).
// Fonte de verdade: /Meu Drive/AMUZZE/Monetizacao/ModeloFinanceiro_v2.md
//
// Quando o modelo for atualizado, sincronizar aqui. Eventualmente migrar pra
// config persistida (tabela company_targets) pra permitir edição via admin
// sem deploy — por enquanto, hardcoded é suficiente.

export interface MonthlyTarget {
  month_index: number;
  mau:         number;
  mrr_brl_net: number;
  infra_cost:  number;
}

export const CONSERVATIVE_TARGETS: MonthlyTarget[] = [
  { month_index: 1,  mau: 100,  mrr_brl_net: 10,   infra_cost: 110 },
  { month_index: 2,  mau: 250,  mrr_brl_net: 26,   infra_cost: 125 },
  { month_index: 3,  mau: 500,  mrr_brl_net: 52,   infra_cost: 150 },
  { month_index: 4,  mau: 900,  mrr_brl_net: 188,  infra_cost: 180 },
  { month_index: 5,  mau: 1400, mrr_brl_net: 292,  infra_cost: 220 },
  { month_index: 6,  mau: 2000, mrr_brl_net: 417,  infra_cost: 270 },
  { month_index: 7,  mau: 2800, mrr_brl_net: 876,  infra_cost: 350 },
  { month_index: 8,  mau: 3700, mrr_brl_net: 1158, infra_cost: 450 },
  { month_index: 9,  mau: 4700, mrr_brl_net: 1471, infra_cost: 570 },
  { month_index: 10, mau: 5800, mrr_brl_net: 1815, infra_cost: 700 },
  { month_index: 11, mau: 6900, mrr_brl_net: 2159, infra_cost: 830 },
  { month_index: 12, mau: 8000, mrr_brl_net: 2503, infra_cost: 970 },
];

// Conversão Pro target — derivada do modelo: subscribers ativos / MAU.
// Premissa: ARPU líquido = R$ 14,90 * (1 - 0,30) = R$ 10,43/sub/mês.
// subscribers_ativos = MRR_net / ARPU → conversion = subscribers_ativos / MAU.
const ARPU_NET_BRL = 14.90 * 0.70;

export function conversionTarget(month_index: number): number {
  const t = CONSERVATIVE_TARGETS.find(x => x.month_index === month_index);
  if (!t || t.mau === 0) return 0;
  const active = t.mrr_brl_net / ARPU_NET_BRL;
  return +(active / t.mau * 100).toFixed(2);
}

// Churn target conservador — 5% mensal (premissa do ModeloFinanceiro_v2).
export const CHURN_TARGET_PCT = 5;
